function formatBenefitsFootnoteNumber(benefits, benefit) {
  let footNoteNumber = 0;
  if (!benefit.description) {
    return null;
  }
  for (const b of benefits) {
    if (b.description) {
      footNoteNumber += 1;
    }
    if (b === benefit) {
      return footNoteNumber;
    }
  }
  return null;
}
export {
  formatBenefitsFootnoteNumber
};
